<template>
  <div class="shop">
    <h2>店铺信息</h2>
    <div class="normal">店铺名称：
      <div class="inputBox">
        <el-input v-model="name"></el-input>
      </div>
    </div>
    <div class="normal">所属平台：
      <el-select v-model="platform" filterable placeholder="选择平台" default-first-option>
        <el-option v-for="item in pList" :key="item" :label="item" :value="item">
        </el-option>
      </el-select>
    </div>

    <div>
      <el-button @click="upToDb" type="primary">上传</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        shop_id: '',  
        name: '',   // 店铺名称
        platform: '',  // 店铺所在平台
        pList: ['京东','美团'],
      }
    },
    beforeRouteEnter(to, from, next) {
      if(from.name === 'login') {
        to.meta.isBack = true;
      }
      next();
    },
    activated() {
      if(!this.$route.meta.isBack){
        let origin = this.$options.data();
        Object.assign(this.$data, origin)
        this.init();
      }
      this.$route.meta.isBack=false
    },
    methods: {

      init() {
        let that = this
        let obj = that.$route.params
        if (obj.id) {
          that.$axios.get(that.$url_prefix + 'queryOneById', {
            params: {
              id: obj.id,
              db: 'ShopModel'
            }
          }).then(function (res) {
            let shop = res.data.data;
            console.log('shop', shop);
            that.shop_id = shop.id;
            that.platform = shop.platform;
            that.name = shop.name;
          }).catch(function (res) {
            console.log('queryAd fail', res);
            that.$message.error('查询失败, 请检查网络');
          })
        }
      },

      //上传数据库
      upToDb() {
        let that = this
        if (!that.name) {
          that.$message.error('请填写店铺名称')
          return;
        }
        if (!that.platform) {
          that.$message.error('请选择店铺所在平台')
          return;
        }

        let obj = {};
        if (that.shop_id) {
          obj.id = that.shop_id;
        }
        obj.name = that.name;
        obj.platform = that.platform;
        let param = {
          'db': 'ShopModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('发送返回', res)
          that.$router.push({
            path: '/IndexPage'
          })
        }).catch(function (res) {
          console.log('上传失败', res)
        })

      },

    }
  }

</script>

<style scoped>
  .shop {
    text-align: center;
    overflow: hidden;
  }

  h2 {
    margin-top: 50px;
  }

  .inputBox {
    display: inline-block;
  }

</style>



// WEBPACK FOOTER //
// src/page/Shop.vue